import React from "react";
import { X, Download, FileText, Loader2 } from "lucide-react";
import { PDFViewer, PDFDownloadLink } from "@react-pdf/renderer";
import { WorkOrderPDFDocument } from "./WorkOrderPDFDocument";

export function PDFPreviewModal({
    open,
    onClose,
    details,
    contractor,
    organization
}) {
    if (!open) return null;

    return (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 backdrop-blur-sm p-4 md:p-8 animate-in fade-in duration-200">
            <div className="bg-white rounded-xl shadow-2xl w-full max-w-5xl h-[90vh] flex flex-col overflow-hidden animate-in zoom-in-95 duration-200">
                {/* Modal Header */}
                <div className="flex items-center justify-between p-4 border-b border-gray-100 bg-gray-50/50">
                    <div className="flex items-center gap-3">
                        <div className="bg-sm-primary/10 p-2 rounded-lg">
                            <FileText className="h-5 w-5 text-sm-primary" />
                        </div>
                        <div>
                            <h2 className="text-lg font-semibold text-gray-900">Work Order Preview</h2>
                            <p className="text-xs text-muted-foreground">Review and download the work order document</p>
                        </div>
                    </div>
                    <div className="flex items-center gap-3">
                        <PDFDownloadLink
                            document={
                                <WorkOrderPDFDocument
                                    details={details}
                                    contractor={contractor}
                                    organization={organization}
                                />
                            }
                            fileName={`WorkOrder_${details.id}.pdf`}
                        >
                            {({ loading }) => (
                                <button
                                    disabled={loading}
                                    className="inline-flex items-center gap-2 px-4 py-2 bg-sm-primary text-white rounded-lg text-sm font-medium hover:bg-sm-primary/90 transition-all disabled:opacity-50"
                                >
                                    {loading ? (
                                        <>
                                            <Loader2 className="h-4 w-4 animate-spin" />
                                            Preparing...
                                        </>
                                    ) : (
                                        <>
                                            <Download className="h-4 w-4" />
                                            Download PDF
                                        </>
                                    )}
                                </button>
                            )}
                        </PDFDownloadLink>
                        <button
                            onClick={onClose}
                            className="p-2 hover:bg-gray-100 rounded-full transition-colors"
                        >
                            <X className="h-5 w-5 text-gray-500" />
                        </button>
                    </div>
                </div>

                {/* Modal Content - PDF Viewer */}
                <div className="flex-1 bg-gray-100 p-2 md:p-4 overflow-hidden relative">
                    <div className="w-full h-full bg-white rounded shadow-sm overflow-hidden">
                        <PDFViewer className="w-full h-full border-none">
                            <WorkOrderPDFDocument
                                details={details}
                                contractor={contractor}
                                organization={organization}
                            />
                        </PDFViewer>
                    </div>
                </div>

                {/* Modal Footer */}
                {/* <div className="p-3 border-t border-gray-100 bg-gray-50/50 text-center">
                    <p className="text-[10px] text-muted-foreground uppercase tracking-wider font-medium">
                        Powered by SiteMaster • Computer Generated Document
                    </p>
                </div> */}
            </div>
        </div>
    );
}
